/*
 * @Author: your name
 * @Date: 2021-11-25 00:12:27
 * @LastEditTime: 2021-11-25 02:08:11
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /static-pc/src/services/articleService.js
 */
import request from '@/utils/request'
import API from '@/apis/api-types'


export function getArticleList (req){
  return request({
    method: 'get',
    url: API.getArticleList,
    params: req
  })
}
export function getArticleDetail (newsId = ''){
  return request({
    method: 'get',
    url: API.getArticleDetail,
    params: {newsId}
  })
}